module.exports = "<app-tab-group-reporting></app-tab-group-reporting>\r\n"